import mediaScreen from "core/checkMedia.core";
import transitionReset from "core/transitionReset.core"
import UI from "./elements.module";

class NavigationModule {

	// Get DOM elements
	private ui = new UI()

	// Private Methods
	private get currentPage() {
		return window.location.pathname;
	}

	private getHrefAttribute(element: HTMLElement) {
		return element.querySelector("a")?.getAttribute("href") as string
	}

	private setActiveLink(listItem: HTMLElement, classList: string) {
		const hasDropdown = listItem.closest(".dropdown")
		if (this.getHrefAttribute(listItem) === this.currentPage) {
			listItem.classList.add(classList)

			if (listItem.closest(".navBarListItem")) {
				listItem.closest(".navBarListItem")?.classList.add(classList)
			}

			if (listItem.classList.contains('active') && hasDropdown) {
				hasDropdown?.closest("li")?.classList.add("active")
			} else {
				hasDropdown?.closest("li")?.classList.remove("active")
			}

		}
	}

	private resetAttributes() {
		this.ui.navBar?.removeAttribute('data-mobile-nav')
		this.ui.navBarToggle?.setAttribute('aria-expanded', 'false')
		this.ui.navBarLists?.removeAttribute('aria-expanded')
		this.ui.navBarDropdown?.forEach(dropdown => {
			dropdown?.removeAttribute('data-nav-dropdown')
		})
		document.body.removeAttribute('data-overlay')
	}

	// Public Methods
	disableAttributes() {
		transitionReset("[data-navbar]", ".main-nav")

		mediaScreen('min-width', '992', (e: MediaQueryListEvent) => {
			if (e.matches) {
				this.resetAttributes()
			} else {
				this.ui.navBarLists?.removeAttribute('aria-expanded')
				document.body.removeAttribute('data-overlay')
			}
		})

	}

	handleActiveLinkOnPageLoad(): void {
		let linkItem: HTMLAnchorElement | null = null
		let linkHref: string | null = null

		this.ui.navBarList?.forEach(listItem => {
			this.setActiveLink(listItem, "active");
			if (listItem.classList.contains("active")) {
				linkItem = listItem?.querySelector("a") as HTMLAnchorElement
				linkHref = this.getHrefAttribute(listItem)
			}

		})
	}

	handleNavBarToggleButton(): void {
		const headerIntersect = document.querySelector('header')?.previousElementSibling
		this.ui.navBarToggle?.addEventListener('click', () => {
			this.ui.navBarToggle?.setAttribute('aria-expanded', `${!(this.ui.navBarToggle?.getAttribute('aria-expanded') === 'true')}`)
			this.ui.navBar?.setAttribute('aria-expanded', `${!(this.ui.navBar?.getAttribute('aria-expanded') === 'true')}`)
			// document.body.toggleAttribute('data-overlay')
			// if (document.body.hasAttribute('data-overlay')) {
			// 	headerIntersect?.setAttribute("has-overlay", `${!(headerIntersect?.getAttribute('has-overlay') === 'true')}`)
			// } else {
			// 	headerIntersect?.removeAttribute("has-overlay")
			// }

			this.handleOverlayClick()
		})
	}

	handleNavBarDropdown(): void {
		this.ui.navBarDropdown?.forEach(dropdown => {
			dropdown?.closest("li")?.addEventListener("click", (e) => {
				dropdown?.toggleAttribute("data-nav-dropdown")

				mediaScreen('min-width', '991', (e: MediaQueryListEvent) => {
					if (e.matches) {
						if (dropdown?.hasAttribute('data-nav-dropdown')) {
							dropdown?.removeAttribute('data-nav-dropdown')
						}
						dropdown?.removeAttribute('data-nav-dropdown')
					}
				})
			})
		})


	}

	handleNavigationOverflow(): void {
		mediaScreen('max-width', '991', (e: MediaQueryListEvent) => {
			const navObserver = new ResizeObserver((entries) => {
				if (e.matches) {
					entries.forEach(entry => {
						const target = this.ui.navBar as HTMLElement
						const content = entry.contentRect.height
						const targetHeight = target.getBoundingClientRect().height

						if (content <= 0) {
							target.removeAttribute("style")
						}
						if (content > 0 || content <= 0 && targetHeight > 413) {
							target.style.overflowY = "scroll"
							target.style.height = `${413}px`
						}
					})
				}
			})

			this.ui.navBarDropdown?.forEach(dropdown => {
				navObserver.observe((dropdown) as HTMLElement)
			})
		})

	}

	handleOverlayClick() {
		const headerIntersect = document.querySelector('header')?.previousElementSibling
		headerIntersect?.addEventListener('click', () => {
			// this.resetAttributes()
			headerIntersect.removeAttribute("has-overlay")

		})
	}
}

export default NavigationModule
